"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRequest = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var logger_1 = require("../logger");
function makeRequest(headers, method, url, json, retries) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        if (method === 'POST') {
            xhr.setRequestHeader('Content-type', 'application/json');
        }
        if (firefly_utilities_helper_ts_1.isObject(headers)) {
            for (var key in headers) {
                if (headers.hasOwnProperty(key)) {
                    xhr.setRequestHeader(key, headers[key]);
                }
            }
        }
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                logger_1.logDebug(this.responseText);
                resolve(xhr.response);
            }
            else {
                // @ts-ignore
                if (retries > 0) {
                    // @ts-ignore
                    retries -= 1;
                    return makeRequest(headers, method, url, json, retries);
                }
                else {
                    logger_1.logError(xhr.statusText);
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            }
        };
        xhr.onerror = function () {
            // @ts-ignore
            if (retries > 0) {
                // @ts-ignore
                retries -= 1;
                return makeRequest(headers, method, url, json, retries);
            }
            else {
                logger_1.logError(xhr.statusText);
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        if (!firefly_utilities_helper_ts_1.isNullOrUndefined(json)) {
            var data = JSON.stringify(json);
            xhr.send(data);
        }
        else {
            xhr.send();
        }
    });
}
exports.makeRequest = makeRequest;
